import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { FormBuilder, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { NgbModal, NgbNavModule } from '@ng-bootstrap/ng-bootstrap';
import { NotificationService } from '../../../services/notification.service';
import { Router } from '@angular/router';
import { User } from '../../../models/user';
import { AdminDashboardService } from '../../../services/admin-dashboard.service';
import { UiNotificationModel } from '../../../models/ui-notification-model';
import { FeatherIconComponent } from '../../../shared/components/common/feather-icon/feather-icon.component';
import { AuthService } from '../../../services/auth.service';
import { generateRandomId } from '../../../helpers/utils';

@Component({
  selector: 'app-add-celebrity',
  standalone: true,
  imports: [FeatherIconComponent,NgbNavModule, ReactiveFormsModule, CommonModule],
  templateUrl: './add-celebrity.component.html',
  styleUrl: './add-celebrity.component.scss'
})
export class AddCelebrityComponent {
  registerForm2?: FormGroup;
  isRegisterSubmited2: boolean = false;
  nom: string;
  public domains: any[] = [];
  isLoading: boolean = false;

  constructor(
    private adminService: AdminDashboardService,
    public modalServices: NgbModal,
    private notificationService: NotificationService,
    private fb: FormBuilder, 
    private router: Router,
    private authService: AuthService
  ) { }

  ngOnInit(): void {
    this.registerForm2 = this.fb.group({
          prenom: ['', Validators.required],
          name: ['', Validators.required],
          nom: [{ value: '', disabled: true }],
          telephone: ['', Validators.required],
          email: ['', [Validators.required, Validators.email]],
          domain_id: [''],
          rang: ['star'],
          nationalite_id: ['1'],
          password: ['', [Validators.required, Validators.minLength(6)]],
          password_confirmation: ['', [Validators.required, Validators.minLength(6)]],
          scene_name: ['', Validators.required],
        });
    
        this.registerForm2.get('name')?.valueChanges.subscribe(value => {
          this.registerForm2?.patchValue({ nom: value }, { emitEvent: false });
        });
      
        this.displayDomains();
    }


  get registerFormControls2() {
    return this.registerForm2?.controls;
  }

  handleSubmitRegister2(event: any) {
    event.preventDefault();
    this.isRegisterSubmited2 = true;
  
    if (this.registerForm2?.invalid) {
      console.log('Formulaire invalide:', this.registerForm2.value);
      return;
    }

    this.isLoading = true; // Activer le chargement
    console.log(this.registerForm2?.value);

    this.registerForm2?.get('nom')?.enable();
    const user: User = this.registerForm2?.value;

    console.log(this.registerForm2?.value);

    this.adminService.register(user).subscribe({
      next: (data) => {

        console.log(data);        
        this.isLoading = false; // Désactiver le chargement
        this.notificationService.create('success');
        console.log('User data:', data);
        this.modalServices.dismissAll();
        this.router.navigate(["/admin/celebrities"]);
      },
      error: (err) => {
        console.error('Erreur de l’API:', err);
        this.isLoading = false; // Désactiver le chargement
        this.notificationService.create(err?.error?.errors || 'Erreur inconnue', 'danger', 2000);
      },
    });

    this.registerForm2?.get('nom')?.disable();
  }

  displayDomains(){
    this.authService.getDomains().subscribe({
      next: (data) => {
        
        this.domains = data.data;
        console.log(this.domains);
      }
    });
  }


    emit(){
                const notification:UiNotificationModel = {
                  _id:generateRandomId(),
                  title: "Test",
                  message: "This is a test notification",
                  status: "danger",
                  timeout: 2000
                }
                this.notificationService.emit(notification)
                console.log('notification:', notification.message);
              }
}
